module.exports = __webpack_public_path__ + "static/media/introduce.43ace589.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E5L/introduce.png
// module id = 728
// module chunks = 0